// extracted by mini-css-extract-plugin
export default {"container":"bottomTimer_container__CeFzJ","timer":"bottomTimer_timer__lqBI3","title":"bottomTimer_title__uGgj2","buyButtonContainer":"bottomTimer_buyButtonContainer__MQRiw"};